import { useEffect, useState } from "react";
import {
  getBankTransfers,
  rehydrateBankTransfers,
  setAllBankTransfers,
  subscribeBankTransfers,
  type BankTransferRecord,
} from "../lib/bankTransferStore";

export function useBankTransfers() {
  const [transfers, setTransfers] = useState<BankTransferRecord[]>(() => getBankTransfers());

  useEffect(() => {
    void rehydrateBankTransfers();
    const unsubscribe = subscribeBankTransfers(() => setTransfers(getBankTransfers()));
    setTransfers(getBankTransfers());
    return unsubscribe;
  }, []);

  return {
    transfers,
    setAllBankTransfers,
  };
}
